export default __webpack_public_path__ + "static/media/3-5-4.88d3211a.jpg";